// extracted by mini-css-extract-plugin
export var option = "_99-0";
export var optionCard = "_99-f";
export var optionContent = "_99-g";
export var optionIcon = "_99-i";
export var optionIconBox = "_99-h";
export var optionLabel = "_99-j";
export var optionPill = "_99-m";
export var optionPillBadge = "_99-p";
export var optionPillIcon = "_99-n";
export var optionPillLabel = "_99-o";
export var optionRadio = "_99-k";
export var optionRadioInner = "_99-l";
export var optionReveal = "_99-2";
export var optionRevealDelay0 = "_99-3";
export var optionRevealDelay1 = "_99-4";
export var optionRevealDelay10 = "_99-d";
export var optionRevealDelay11 = "_99-e";
export var optionRevealDelay2 = "_99-5";
export var optionRevealDelay3 = "_99-6";
export var optionRevealDelay4 = "_99-7";
export var optionRevealDelay5 = "_99-8";
export var optionRevealDelay6 = "_99-9";
export var optionRevealDelay7 = "_99-a";
export var optionRevealDelay8 = "_99-b";
export var optionRevealDelay9 = "_99-c";
export var optionSelected = "_99-1";